module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "for"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/foreword#for"
    }
  }, [_c('i', [_vm._v("Foreword")]), _vm._v(" by Rick Steves")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Preface: A Lens of Hope")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part001#pt001"
    }
  }, [_vm._v("I. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDING")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OST")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNGER")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S WITHIN")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACH")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Silence Can Kill")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("We Could Soon End Most US Hunger")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("We Could Help End Global Hunger and Poverty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part002#pt002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PEAKING TO")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLITICAL")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWER")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AN")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVES")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Why We Should “Lobby” Our Members of Congress")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Charity Is Essential but Limited")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Charities Cannot Make National Policy")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Government Must Lead")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part003#pt003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UR")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CONOMY")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AIR AND")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCLUSIVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Wrenching Inequalities")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Family Erosion")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-010"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("Taxes and Deficits")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("An Economy That Works for Everybody")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part004#pt004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AN")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CT ON A")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMPELLING")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISION")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#ch012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("We Need a Compelling Vision")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#ch013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("Breaking the Silence")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#ch014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("Faith, Love, and Justice")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-1",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgements#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "note"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "idx-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0